<template>
  <nav class="pull-right">
    <ul class="pagination">
      <li>
        <a href="#" :disabled="disablePrevious" @click.prevent="previousPage()">
          <span>
            <i class="icon ion-ios-arrow-left"></i>
          </span>
        </a>
      </li>
      <li class="middle" v-if="$slots.middle">
        <slot name="middle"></slot>
      </li>
      <li>
        <a href="#" :disabled="disableNext" @click.prevent="nextPage()">
          <span>
            <i class="icon ion-ios-arrow-right"></i>
          </span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    disablePrevious: {
      type: Boolean,
      deafult: false,
    },
    disableNext: {
      type: Boolean,
      deafult: false,
    },
  },
  data() {
    return {}
  },
  methods: {
    previousPage() {
      if (this.disablePrevious) return

      this.$emit('previousPage')
    },
    nextPage() {
      if (this.disableNext) return

      this.$emit('nextPage')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Pagination.vue